/* eslint-disable no-shadow,consistent-return,no-param-reassign, max-len */
import apiCompanyProfile from '@/services/jApiCompanyProfile';

const state = {
  // Set default state(s) here
  state_company_profile: {
    updated: false,
    detail: null,
    banner: null,
  },
};

const getters = {
  // Change value of state(s) with getter
};

const mutations = {
  CompanyProfileUpdated(state) {
    state.state_company_profile.updated = !state.state_company_profile.updated;
  },
  showDetailCompanyProfile(state, payload) {
    state.state_company_profile.detail = payload;
  },
  showCompanyBanner(state, payload) {
    state.state_company_profile.banner = payload;
  },
};

const actions = {
  async actionGetCompanyDetail({ dispatch, commit }) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiCompanyProfile.getCompanyProfileDetail();
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('showDetailCompanyProfile', res.data);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },
  async actionGetCompanyBanner({ dispatch, commit }, params) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiCompanyProfile.getCompanyBanner(params);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('showCompanyBanner', res.data[0]);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },
  async actionUpdateCompanyProfile({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiCompanyProfile.updateCompanyProfile(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', 'Error! Failed to update company profile', { root: true });
      } else {
        commit('CompanyProfileUpdated');
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', 'Company Profile Updated Successfully', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', 'Error! Failed to update company profile, please try again', { root: true });
    }
  },
  async actionCreateCompanyBanner({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiCompanyProfile.createCompanyBanner(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('CompanyProfileUpdated');
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', 'Error!', { root: true });
    }
  },
  async actionUpdateCompanyBanner({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiCompanyProfile.updateCompanyBanner(data, state.state_company_profile.banner.id);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('CompanyProfileUpdated');
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', 'Error!', { root: true });
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreCompanyProfile.js